module.exports = __webpack_public_path__ + "static/media/official.c638474.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/la_liga/official.mp4
// module id = IBWP
// module chunks = 1